module.exports = __webpack_public_path__ + "img/horizontal_7_5_5012.9eeef301.png";